import { BaseButton, Popover } from '@libs/ui/ds'
import type { DatePickerTargetWrapTypes } from '@libs/ui/ds/lib/components/dates/DatePickerInput/specialized/DatePickerInput/subs/DatePickerCustomTargetWrap.types'
import { outlineFocusMixin } from '@libs/ui/ds/lib/styles/mixins/mixins'
import { cva } from 'class-variance-authority'
import type { FC, ReactNode } from 'react'

type Props = {
  children: ReactNode
  disabled?: boolean
  errorMessage?: ReactNode
} & DatePickerTargetWrapTypes

const targetInputLikeCVA = {
  inner: cva(
    [
      'relative flex h-10 w-full min-w-0 items-center justify-between gap-2 px-4 py-2',
      'rounded-md border-1 font-sans text-m font-normal',
      outlineFocusMixin
    ],
    {
      variants: {
        disabled: {
          true: ['border-neutral-300 bg-neutral-100 text-neutral-500'],
          false: [
            'cursor-pointer !border-neutral-200 !bg-neutral-50 hover:bg-neutral-100/70'
          ]
        },
        error: {
          true: ['border-semantic-red-400']
        }
      }
    }
  ),
  content: cva(['inline-block grow truncate text-s font-normal'], {
    variants: {
      placeholder: {
        true: 'text-left text-neutral-500',
        false: 'text-start text-neutral-700'
      },
      disabled: {
        true: '!text-neutral-400'
      }
    }
  })
}

export const DatePickerTargetInputLike: FC<Props> = ({
  children,
  disabled = false,
  errorMessage,
  ...otherProps
}) => {
  return (
    <Popover.Target>
      <BaseButton
        {...otherProps}
        className={targetInputLikeCVA.inner({
          disabled,
          error: Boolean(errorMessage)
        })}
      >
        <div
          className={targetInputLikeCVA.content({
            disabled,
            placeholder: Boolean(otherProps.placeholder)
          })}
        >
          {children}
        </div>
      </BaseButton>
    </Popover.Target>
  )
}
